import axios from 'axios';
import { keysToCamelCase } from '@hotjar/webapp/lib/convert-string';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import type { Customer, CustomerDto } from './customer.types';

function mapCutomerDtoToModel(customerDto: CustomerDto): Customer {
  return keysToCamelCase(customerDto, true);
}

export async function getCustomer(accountId?: number): Promise<Customer> {
  if (accountId === undefined) {
    return Promise.reject(new Error('Invalid id'));
  }
  const url = `/api/checkout/customers/${accountId}`;
  const response = await axios.get<CustomerDto>(url);

  return mapCutomerDtoToModel(response.data);
}

const CUSTOMER_QUERY_KEY = 'zuora-customer';

export const useCustomer = (accountId?: number): UseQueryResult<Customer, Error> => {
  return useQuery(CUSTOMER_QUERY_KEY, () => getCustomer(accountId), {
    enabled: Boolean(accountId),
    retry: false,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};
